import { BookOpen } from 'lucide-react';

export function ETRSection() {
  return (
    <section id="etr" className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
      <div className="flex items-center gap-4 mb-6">
        <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
          <BookOpen className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
        </div>
        <h2 className="card-title">
          Tekst łatwy do czytania (ETR)
        </h2>
      </div>

      <div className="space-y-6">
        <p className="body-medium">
          Fundacja Znajdki istnieje od 2012 roku.
        </p>

        <div className="space-y-3">
          <h3 className="heading-5">Czym zajmuje się Fundacja:</h3>
          <ul className="list-disc pl-6 space-y-2 body-medium">
            <li>pomaga bezdomnym psom i kotom</li>
            <li>pomaga kotom wolno żyjącym</li>
            <li>leczy chore zwierzęta</li>
            <li>kastruje, aby ograniczyć rozmnażanie</li>
            <li>szuka nowych domów dla bezdomnych zwierząt</li>
            <li>edukuje</li>
            <li>promuje dobrą adopcję</li>
            <li>uczy dbania o środowisko</li>
          </ul>
        </div>

        <div className="space-y-3">
          <h3 className="heading-5">Nasze zasady:</h3>
          <ul className="list-disc pl-6 space-y-2 body-medium">
            <li>zwierzęta do czasu adopcji przebywają w przytulisku i domach tymczasowych</li>
            <li>zanim zaadoptujesz zwierzę, musisz je poznać</li>
            <li>my musimy poznać Ciebie i Twój dom</li>
            <li>adoptując psa lub kota podpisujesz umowę adopcyjną</li>
            <li>zobowiązujesz się do opieki nad zwierzęciem do końca jego życia</li>
          </ul>
        </div>

        <div className="space-y-3">
          <h3 className="heading-5">Jak pomóc Fundacji:</h3>
          <ul className="list-disc pl-6 space-y-2 body-medium">
            <li>zostać wolontariuszem</li>
            <li>zorganizować zbiórkę dla zwierząt</li>
            <li>przekazać potrzebne rzeczy</li>
            <li>adoptować wirtualnie potrzebujące zwierzę</li>
            <li>pomagać w opiece nad zwierzętami w przytulisku</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

